import React, { useState } from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import ContenuLibre from "../../components/ContenuLibre/contenu-libre"
import Ariane from "gatsby-theme-blank/src/components/Ariane/ariane"
import {
  listEventsContainer,
  eventsContainer,
  eventsItem,
  eventsItemContainer,
  zoneEventsLibreHaut,
  zoneEventsLibreBas,
  eventsFilters,
  eventsFilterByPeriod,
  eventsFilterByTaxo,
  eventsFiltersTaxo,
  eventsFiltersTaxoActive,
} from "./styles/listEvents.module.scss"
import PropTypes from "prop-types"
import {
  EventsFilters,
  EventsItem,
  BorderTaxo,
  EventsPeriodFilter,
  EventsPeriodFilterContainer,
} from "./styled-components/evenements-styled"
import SEO from "gatsby-theme-blank/src/components/seo"
import FadeIn from "react-fade-in"
import EvenementItem from "./listItems/evenement-item"
import { getExistingTaxosInItems } from "gatsby-theme-blank/src/templates/list/utils/get-existing-taxos-in-items"
import { getPublishedData } from "gatsby-theme-blank/src/components/get-published-data"

//-----------------------Query Graphql---------------------------//

export const query = graphql`
  query {
    allNodeEvenements(sort: { fields: field_date_de_debut, order: DESC }) {
      ...ListEvents
    }
  }
`
//-----------------------Query Graphql---------------------------//

//-----------------------Parent component---------------------------//

const EvenementsTemplate = ({ data }) => {
  const publishedData = getPublishedData(data.allNodeEvenements.edges)
  const relatedTaxos =
    publishedData.length > 0
      ? getExistingTaxosInItems(publishedData).join()
      : []
  return (
    <Layout>
      <SEO
        title="Liste des évènements"
        description={
          "Dans cette page, vous découvrez tous les évènements, mais aussi l'ensemble des thématiques suivantes : " +
          relatedTaxos
        }
      />
      <FadeIn delay={100} transitionDuration={400}>
        <Ariane pageName="Tous les évènements" isListing={true} />
        <section className={zoneEventsLibreHaut}>
          <ContenuLibre zoneTaxoLibre="zone_evenements_haut" />
        </section>
        <Filtres eventsData={data} />
        <section className={zoneEventsLibreBas}>
          <ContenuLibre zoneTaxoLibre="zone_evenements_bas" />
        </section>
      </FadeIn>
    </Layout>
  )
}
//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const Filtres = ({ eventsData }) => {
  const publishedData = getPublishedData(eventsData.allNodeEvenements.edges)
  const relatedTaxos =
    publishedData.length > 0 ? getExistingTaxosInItems(publishedData) : []
  const [chooseTaxo, setChooseTaxo] = useState("")
  return (
    <>
      <EventsFilters className={eventsFilters}>
        <div className={eventsFilterByTaxo}>
          <h3>Types d&apos;évènement(s) : </h3>
          {relatedTaxos.map((element, index) => {
            let taxoActiveClass = false
            if (chooseTaxo === element) {
              taxoActiveClass = true
            }
            return (
              <React.Fragment key={index}>
                <BorderTaxo
                  activeBool={taxoActiveClass}
                  activeText={"#fff"}
                  tabIndex={0}
                  role="button"
                  className={
                    taxoActiveClass
                      ? eventsFiltersTaxoActive
                      : eventsFiltersTaxo
                  }
                  onClick={() => {
                    if (chooseTaxo === "" || chooseTaxo !== element) {
                      setChooseTaxo(element)
                    } else if (chooseTaxo === element) {
                      setChooseTaxo("")
                    }
                  }}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      if (chooseTaxo === "" || chooseTaxo !== element) {
                        setChooseTaxo(element)
                      } else if (chooseTaxo === element) {
                        setChooseTaxo("")
                      }
                    }
                  }}
                >
                  {element}
                </BorderTaxo>
              </React.Fragment>
            )
          })}
        </div>
      </EventsFilters>
      <FiltreEvenement eventsData={publishedData} taxoChoisie={chooseTaxo} />
    </>
  )
}
//-----------------------Child component---------------------------//

//-----------------------Sub-Child component---------------------------//

const FiltreEvenement = ({ eventsData, taxoChoisie }) => {
  const [numberOfItems, setNumberOfItems] = useState(6)
  const [eventsPeriod, setEventsPeriod] = useState("incoming")
  let filteredData = []
  filteredData = eventsData.reduce((acc, node) => {
    let matchingTaxo = []
    matchingTaxo = node.node.relationships.field_taxonomie_thematique.filter(
      (taxo) => taxo.name === taxoChoisie
    )
    if (matchingTaxo.length > 0) {
      acc.push(node)
    }
    return acc
  }, [])
  const now = new Date()
  filteredData = taxoChoisie === "" ? eventsData : filteredData
  let finalFilteredData = undefined
  let othersData = undefined
  const incomingEvents = filteredData
    .filter(({ node }) => {
      if (node.fields.formatted_for_compare_field_date_de_fin) {
        if (
          new Date(node.fields.formatted_for_compare_field_date_de_fin) >= now
        ) {
          return true
        }
      } else if (
        new Date(
          node.fields.formatted_for_compare_field_date_de_debut
        ).setHours(0, 0, 0, 0) > now.setHours(0, 0, 0, 0)
      ) {
        return true
      }
      return false
    })
    .sort((firstDate, lastDate) => {
      if (
        firstDate.node.fields.formatted_for_compare_field_date_de_debut >
        lastDate.node.fields.formatted_for_compare_field_date_de_debut
      )
        return 1
      if (
        firstDate.node.fields.formatted_for_compare_field_date_de_debut <
        lastDate.node.fields.formatted_for_compare_field_date_de_debut
      )
        return -1
      return 0
    })
  const inProgressEvents = filteredData.filter(({ node }) => {
    if (node.fields.formatted_for_compare_field_date_de_fin) {
      if (
        new Date(
          node.fields.formatted_for_compare_field_date_de_debut
        ).setHours(0, 0, 0, 0) <= now.setHours(0, 0, 0, 0) &&
        new Date(node.fields.formatted_for_compare_field_date_de_fin).setHours(
          0,
          0,
          0,
          0
        ) >= now.setHours(0, 0, 0, 0)
      ) {
        return true
      }
    } else if (
      new Date(node.fields.formatted_for_compare_field_date_de_debut).setHours(
        0,
        0,
        0,
        0
      ) === now.setHours(0, 0, 0, 0)
    ) {
      return true
    }
    return false
  })
  const pastEvents = filteredData.filter(({ node }) => {
    if (node.fields.formatted_for_compare_field_date_de_fin) {
      if (
        new Date(node.fields.formatted_for_compare_field_date_de_fin) <= now
      ) {
        return true
      }
    } else if (
      new Date(node.fields.formatted_for_compare_field_date_de_debut).setHours(
        0,
        0,
        0,
        0
      ) < now.setHours(0, 0, 0, 0)
    ) {
      return true
    }

    return false
  })
  switch (eventsPeriod) {
    case "incoming":
      finalFilteredData = incomingEvents.slice(0, numberOfItems)
      othersData = incomingEvents.slice(numberOfItems)
      break
    case "inprogress":
      finalFilteredData = inProgressEvents.slice(0, numberOfItems)
      othersData = inProgressEvents.slice(numberOfItems)
      break
    case "past":
      finalFilteredData = pastEvents.slice(0, numberOfItems)
      othersData = pastEvents.slice(numberOfItems)
      break
    default:
      finalFilteredData = filteredData.slice(0, numberOfItems)
      othersData = filteredData.slice(numberOfItems)
      break
  }
  const tabPeriod = [
    {
      incoming: "A venir",
    },
    {
      inprogress: "En cours",
    },
    {
      past: "Passés",
    },
  ]
  return (
    <>
      <section className={listEventsContainer}>
        <div className={eventsContainer}>
          <EventsPeriodFilterContainer className={eventsFilterByPeriod}>
            {tabPeriod.map((element, index) => {
              const propertyName = Object.getOwnPropertyNames(element)[0]
              const value = element[propertyName]
              return (
                <EventsPeriodFilter
                  key={index}
                  active={eventsPeriod === propertyName}
                  onClick={() => {
                    if (eventsPeriod !== propertyName) {
                      setEventsPeriod(propertyName)
                    }
                  }}
                >
                  {value}
                </EventsPeriodFilter>
              )
            })}
          </EventsPeriodFilterContainer>
          <RenderEvenements
            taxoChoisie={taxoChoisie}
            eventsData={eventsData}
            filteredData={finalFilteredData}
          />
        </div>
        {othersData.length > 0 && (
          <div className="voirPlus">
            <span
              role="button"
              tabIndex={0}
              onClick={() => setNumberOfItems(numberOfItems + 6)}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  setNumberOfItems(numberOfItems + 6)
                }
              }}
              className="btn"
            >
              Voir plus
            </span>
          </div>
        )}
      </section>
    </>
  )
}
//-----------------------Sub-Child component---------------------------//

//-----------------------Sub-Sub-Child component---------------------------//

const RenderEvenements = ({ filteredData, taxoChoisie }) => {
  if (filteredData.length === 0) {
    return <p style={{ margin: "0 2rem" }}>Pas de contenu à afficher.</p>
  }
  return (
    <div className={eventsItemContainer}>
      {filteredData.map(({ node }) => (
        <EventsItem key={node.title} className={eventsItem}>
          <EvenementItem taxoChoisie={taxoChoisie} evenement={node} />
        </EventsItem>
      ))}
    </div>
  )
}
//-----------------------Sub-Sub-Child component---------------------------//

//-----------------------Prop-Types---------------------------//

EvenementsTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}
RenderEvenements.propTypes = {
  filteredData: PropTypes.array.isRequired,
  taxoChoisie: PropTypes.string.isRequired,
}
FiltreEvenement.propTypes = {
  eventsData: PropTypes.object.isRequired,
  taxoChoisie: PropTypes.string.isRequired,
}
Filtres.propTypes = {
  eventsData: PropTypes.object.isRequired,
}
//-----------------------Prop-Types---------------------------//

export default EvenementsTemplate
